<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
    :disabled="disabled || readonly"
  >
    <template #activator="{ on }">
      <v-text-field
        v-model="formatedDates"
        :label="label"
        readonly
        v-on="on"
        :disabled="disabled"
        prepend-icon="event"
        :dense="dense"
      />
    </template>
    <v-date-picker
      v-model="dates"
      range
      no-title
      color="primary"
      :disabled="disabled"
      :dense="dense"
    />
  </v-menu>
</template>

<script>
import { DateTime } from "luxon";

export default {
  name: "DateFieldRange",
  components: {},
  mixins: [],
  props: {
    value: { type: Array, required: true },
    disabled: { type: Boolean, required: false, default: false },
    label: { type: String, required: false, default: null },
    dense: { type: Boolean, required: false, default: false },
    readonly: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    dates: {
      get() {
        return this.value;
      },
      set(val) {
        if (val.length === 2) {
          val.sort((a, b) => DateTime.fromISO(a) - DateTime.fromISO(b));
        }
        this.$emit("input", val);
      },
    },
    formatedDates() {
      if (this.value[0] && this.value[1]) {
        return `${this.value[0]} to ${this.value[1]}`;
      }
      return "";
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
